import { useEffect, useState } from 'react'
import { isMobile } from '@/utils/layout.utils'

/**
 * Hook to determine if the current viewport is mobile
 * @returns {boolean} mobile
 */
const useIsMobile = (): Nullable<boolean> => {
  const [mobile, setMobile] = useState<Nullable<boolean>>(null)

  useEffect(() => {
    const resize = (): void => {
      setMobile(isMobile())
    }
    resize()
    window.addEventListener('resize', resize)
    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return mobile
}

export default useIsMobile
